import React, { useEffect, useState } from 'react'
import AppLayout from './AppLayout'
import { Link, NavLink } from 'react-router-dom'
import {Add, BarChart, Menu, MenuOpen } from '@mui/icons-material';
import { useAppData } from '../../context/AppDataContext';
import VoucherNav from './VoucherNav';
import ReportNav from './ReportNav';
import GenerateSalePurchaseVoucherForm from '../../app/admin/erp/finance/voucher/component/GenerateSalePurchaseVoucherForm';
import PaymentReceiptVoucherForm from '../../app/admin/erp/finance/voucher/component/PaymentReceiptVoucherForm';
import ContraVoucherForm from '../../app/admin/erp/finance/voucher/component/ContraVoucherForm';
import JournalVoucherForm from '../../app/admin/erp/finance/voucher/component/JournalVoucherForm';
import ExpenseVoucherForm from '../../app/admin/erp/finance/voucher/component/ExpenseVoucherForm';
import GenerateChallanVoucherForm from '../../app/admin/erp/finance/voucher/component/GenerateChallanVoucherForm';
import InventoryTransferForm from '../../app/admin/erp/finance/inventory/components/InventoryTransferForm';


function FinanceLayout({children}) {
    const [voucherNavStatus,setVoucherNavStatus] = useState(false);
    const [reportNavStatus,setReportNavStatus] = useState(false)
    

	useEffect(()=>{
        //document.body.classList.add("bg-info");
        return () => {
            //document.body.classList.remove("bg-info");
        };
    },[])
	const getVoucherList = () =>{

	}

    return (
        
        <AppLayout>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-9'>
                        {children}
                    </div>
                    <div className='col-md-3'>

                        <div className="accordion" id="financeNav">
                          <div className="accordion-item">
                            <button  className="accordion-button py-2" type="button" data-bs-toggle="collapse" aria-expanded="true" aria-controls="generateVoucherList" data-bs-target="#generateVoucherList">
                              Generate New Voucher
                            </button>
                            <div id="generateVoucherList" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#financeNav">
                              <div class="list-group rounded-0 border border-top-0 border-2">
                                <div className='list-group-item p-0 pb-1'><GenerateSalePurchaseVoucherForm voucherType="Sale" callBack={getVoucherList} /></div>
                                <div className='list-group-item p-0 pb-1'><GenerateSalePurchaseVoucherForm voucherType="Purchase" callBack={getVoucherList} /></div>
                                <div className='list-group-item p-0 pb-1'><PaymentReceiptVoucherForm voucherType="Payment" callBack={getVoucherList} /></div>
                                <div className='list-group-item p-0 pb-1'><PaymentReceiptVoucherForm voucherType="Receipt" callBack={getVoucherList} /></div>
                                <div className='list-group-item p-0 pb-1'><ContraVoucherForm callBack={getVoucherList} /></div>
                                <div className='list-group-item p-0 pb-1'><JournalVoucherForm callBack={getVoucherList} /></div>
                                <div className='list-group-item p-0 pb-1'><GenerateChallanVoucherForm voucherType="ChallanOut" callBack={getVoucherList} /></div>
                                <div className='list-group-item p-0 pb-1'><GenerateChallanVoucherForm voucherType="ChallanIn" callBack={getVoucherList} /></div>
                                <div className='list-group-item p-0 pb-1'><ExpenseVoucherForm callBack={getVoucherList} /></div>
                              </div>
                            </div>
                          </div>
                          <div className="accordion-item">
                            <button  className="accordion-button py-2" type="button" data-bs-toggle="collapse" aria-expanded="false" aria-controls="financeConfigList" data-bs-target="#financeConfigList">
                              Configuration
                            </button>
                            <div id="financeConfigList" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#financeNav">
                              <div class="list-group rounded-0 border border-top-0 border-2">
                                <NavLink className="list-group-item list-group-item-action" to="/company/dashboard">Manage Company</NavLink>
                                <NavLink className="list-group-item list-group-item-action" to="/voucher-setting">Voucher Setting</NavLink>
                                <NavLink className="list-group-item list-group-item-action" to="/company-location/list">Location / Warehouse / Godown</NavLink>
                                <NavLink className="list-group-item list-group-item-action" to="/ledger-group/list">Account Group</NavLink>
                                <NavLink className="list-group-item list-group-item-action" to="/party/dashboard">Party</NavLink>
                              </div>
                            </div>
                          </div>
                          <div className="accordion-item">
                            <button  className="accordion-button py-2" type="button" data-bs-toggle="collapse" aria-expanded="false" aria-controls="financeInventoryList" data-bs-target="#financeInventoryList">
                              Stock Journal
                            </button>
                            <div id="financeInventoryList" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#financeNav">
                              <div class="list-group rounded-0 border border-top-0 border-2">
                                <NavLink className="list-group-item list-group-item-action" to="/product/dashboard">Manage Products</NavLink>
                                <NavLink className="list-group-item list-group-item-action" to="/inventory/stock-list">Inventory Stock</NavLink>
                                <NavLink className="list-group-item list-group-item-action" to="/inventory/transactions">Inventory Transaction Log</NavLink>

                                <div className='list-group-item p-0 pb-1'><InventoryTransferForm callBack={getVoucherList} /></div>
                              </div>
                            </div>
                          </div>


                          <div className="accordion-item">
                            <button  className="accordion-button py-2" type="button" data-bs-toggle="collapse" aria-expanded="false" aria-controls="reportsGallery" data-bs-target="#reportsGallery">
                              Reports Gallery
                            </button>
                            <div id="reportsGallery" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#financeNav">
                              <div class="list-group rounded-0 border border-top-0 border-2 ">
                                <NavLink to="/finance/report/daybook" className='list-group-item'>Day Book</NavLink>
                                <NavLink to="/finance/report/gstr1" className='list-group-item'>GSTR1</NavLink>
                                <NavLink to="/finance/report/gstr2" className='list-group-item'>GSTR2</NavLink>
                                <NavLink to="/finance/report/gstr3b" className='list-group-item'>GSTR3B</NavLink>
                                <NavLink to="/voucher/dashboard" className='list-group-item'>Voucher List</NavLink>
                                <NavLink className="list-group-item list-group-item-action" to="/ledger/list">Ledgers</NavLink>
                                <NavLink className="list-group-item list-group-item-action" to="/ledger-entry/list">Ledgers Entries</NavLink>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default FinanceLayout



/*
<div className="accordion" id="accordionExample">
  <div className="accordion-item">
    <h2 className="accordion-header" id="headingOne">
      <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
        Accordion Item #1
      </button>
    </h2>
    <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
      <div className="accordion-body">
        <strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="headingTwo">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
        Accordion Item #2
      </button>
    </h2>
    <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
      <div className="accordion-body">
        <strong>This is the second item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="headingThree">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
        Accordion Item #3
      </button>
    </h2>
    <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
      <div className="accordion-body">
        <strong>This is the third item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
      </div>
    </div>
  </div>
</div>

*/